import XtIBE from './ibe/ibe';


export default window.XtIBE = XtIBE